import { render } from "./SrchClassrooms.vue?vue&type=template&id=49ff05de"
import script from "./SrchClassrooms.vue?vue&type=script&lang=js"
export * from "./SrchClassrooms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__